var _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.11,
    height: 14.886,
    viewBox: "0 0 18.11 14.886",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_45",
    "data-name": "Path 45",
    transform: "translate(3.666)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.222,0A7.222,7.222,0,1,1,0,7.222,7.222,7.222,0,0,1,7.222,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.221957683563232 2.000000953674316 C 4.342557907104492 2.000000953674316 1.999998092651367 4.342580795288086 1.999998092651367 7.222000598907471 C 1.999998092651367 10.10142040252686 4.342557907104492 12.44400024414063 7.221957683563232 12.44400024414063 C 10.10135746002197 12.44400024414063 12.4439172744751 10.10142040252686 12.4439172744751 7.222000598907471 C 12.4439172744751 4.342580795288086 10.10135746002197 2.000000953674316 7.221957683563232 2.000000953674316 M 7.221957683563232 9.5367431640625e-07 C 11.21053791046143 9.5367431640625e-07 14.4439172744751 3.233400344848633 14.4439172744751 7.222000598907471 C 14.4439172744751 11.21060085296631 11.21053791046143 14.44400024414063 7.221957683563232 14.44400024414063 C 3.233377456665039 14.44400024414063 -1.9073486328125e-06 11.21060085296631 -1.9073486328125e-06 7.222000598907471 C -1.9073486328125e-06 3.233400344848633 3.233377456665039 9.5367431640625e-07 7.221957683563232 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M4.988,0,9.977,8.442H0Z",
    transform: "translate(7.311 2.025) rotate(60)",
    fill: "#f8f2e1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_4",
    "data-name": "Polygon 4",
    d: "M2.5,0,5,4H0Z",
    transform: "translate(7.5 10) rotate(180)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBack);
export default __webpack_public_path__ + "static/media/goBack.290cceb50e673c077c9561867aec8c7e.svg";
export { ForwardRef as ReactComponent };